export const SET_HERO_DOT = 'SET_HERO_DOT';
export const SET_NAVBAR_COLOR = 'SET_NAVBAR_COLOR';
export const SET_NAVBAR_OFFSET = 'SET_NAVBAR_OFFSET';
export const SET_SCROLLBAR_COLOR = 'SET_SCROLLBAR_COLOR';
